export const BULK_EDIT_SUPPLIER_DISCOUNT_GROUP = 'bulkEditSupplierDiscountGroup';
